
<template>
  <v-app id="searchIndi">
    <v-main>
    <v-container fluid>  
    <v-card>
      <v-card-title>Layout items</v-card-title>
      <v-simple-table dense>
         <tbody v-for="(indiRecord,i) in searchIndi" :key="i">
           <tr @click="$router.reload('/syst/ref/indi/onIndi/' + indiRecord.indi_encrid)">
             <td>{{indiRecord.indi_nr}}</td>
             <td>{{indiRecord.inditaal_oms}}</td>
             <td>{{indiRecord.inditaal_nl_oms}}</td>
             <td>{{indiRecord.inditaal_de_oms}}</td>
             <td>{{indiRecord.inditaal_fr_oms}}</td>
           </tr>  
         </tbody>  
       </v-simple-table>  
    </v-card>  
    </v-container>
    </v-main>
    <navBar title="Ares - Reference data" :home="true" type="referencedata"/>
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  data() {
    return {
      searchIndi: []
    }  
  },
  mounted() {
      this.$axios
        .post("ares/json/ares/syst/ref/indi/searchIndi.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "searchIndi"
          },
          searchIndi: {
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.searchIndi = res.data.searchIndi;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
};

</script> 
